import React from 'react';
import { FormInfo } from '../services/api';
import './FormSelector.css';

interface Props {
  forms: FormInfo[];
  onSelect: (formId: string, formName?: string) => void;
}

const FormSelector: React.FC<Props> = ({ forms, onSelect }) => {
  return (
    <div className="form-selector">
      {forms.map((form) => (
        <button
          key={form.form_id}
          className="form-option"
          onClick={() => onSelect(form.form_id, form.name)}
        >
          <div className="form-info">
            <span className="form-name">{form.name}</span>
            <span className="form-category">{form.category}</span>
          </div>
          <span className="form-arrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </span>
        </button>
      ))}
    </div>
  );
};

export default FormSelector;
